import script from "./TickCrossBooleanDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./TickCrossBooleanDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./TickCrossBooleanDisplay.vue?vue&type=style&index=0&id=941bdd0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-941bdd0a"]])

export default __exports__